export const environment = {
  production: true,
  config: {
    apiUrl: 'https://api.dev.voidsadrift.com'
  }
};
